import { OrderMarker } from "@/Components/Map/Map";
import { MapScreenSettings, OrderV2 } from "@/shared/v2/queries/interfacesV2";

export const withDefaultSettings = (
  data?: Partial<MapScreenSettings>
): MapScreenSettings => {
  return {
    cluster_options: data?.cluster_options ?? 1,
    sort_options: data?.cluster_options ?? 1,
    statuses: data?.statuses ?? [1, 2, 3, 4],
    show_orders_assigned_to_courier:
      data?.show_orders_assigned_to_courier ?? false,
    pin_code_check: data?.pin_code_check ?? true,
    item_id: data?.item_id ?? -1,
    merge_formulas: data?.merge_formulas ?? false,
    couriers_can_assign_orders_to_themselves:
      data?.couriers_can_assign_orders_to_themselves ?? false,
  };
};

export const toOrders = (
  data: OrderMarker[] | OrderV2[]
): Partial<OrderV2>[] => {
  return data.map((order) => {
    if (order?.order_information?.item_id !== undefined) {
      return order as OrderV2;
    } else {
      return {
        order_user: {
          address_geo_coordinates: {
            2: order?.latitude,
            3: order?.longitude,
          },
        },
        order_information: {
          amount: order.amount,
          count: order.count,
        },
      } as any;
    }
  });
};
